<template>
      <div class="indexheader">
          <div class="linediv"></div>
           <div  class="indexm">
              <img class="logo" src="@/assets/logo.png">
              <div class="flex-1"></div>
              <template v-if="token">
                 <div class="topright">{{realname}}，欢迎您   <span class="tui" @click="out">退出</span> |  <span class="tui2" @click="$router.push('/create')">个人中心</span></div>
              </template>
              <template v-else>
                  <div class="logbtn" @click="$router.push('/login')">登录</div>
                  <div class="zcbtn" @click="$router.push('/register')">注册</div>
               </template>
            </div>
      </div>
</template>

<script>
import { refreshUser,logout } from "@/api/index.js"
export default {
  name: "HomePage",
  data() {
    return {
      
    }
  },
  computed: {
    realname() {
      return  this.$store.state.realname
    },
    token() {
      return  this.$store.state.token
    }
  },
  mounted(){
    refreshUser().then(res=>{
      if(res.code==1){
             this.$store.commit("login",res.data)
       }
       
    })
  },
  methods: {
    out(){
      this.$confirm('确定要退出该账号吗？', '退登确认', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(()=>{
        // 清除账户状态记录
        logout()
        this.$store.commit("logout");
        // 跳转到登录页面
        this.$router.push("/");
        this.$notify({
          title: '成功',
          message: '账号已退出',
          type: 'success'
        });
      })
    }
  }
}
</script>

<style scoped lang="less">

  .indexheader {position: sticky;left:0;top:0;background:#fff;z-index: 99;}
  .linediv {background:#005786;height:12px;}
  .indexm {
     display: flex;align-items:center;width:1200px;margin:20px auto 0px auto;padding-bottom:20px;
     .logo {width:350px;height:44px;}
     .logbtn {width:90px;height:30px;background:#2397CA;border-radius: 6px;color:#fff;font-size: 14px;text-align: center;line-height: 30px;cursor: pointer;}
     .zcbtn {width:90px;height:30px;border-radius: 6px;border:1px solid #2397CA;font-size: 14px;text-align: center;line-height: 30px;cursor: pointer;margin-left:20px;}
     .logbtn:hover {background:#10749f}
     .zcbtn:hover {border:1px solid #10749f;color:#10749f;}
  }
.topright {
    font-size:16px;
    .tui {
      color:#002855;margin-left:10px;cursor: pointer;
    }
    .tui2 { color:#002855;cursor: pointer;}
    .tui:hover,.tui2:hover {text-decoration: underline} 
  }
</style>
